'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: ", ";\n"], ["\n  width: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var AddOnTitle = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: 400 16px/22px ", ";\n  color: ", ";\n"], ["\n  font: 400 16px/22px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var AddOnPrice = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 400 16px/19px ", ";\n  color: ", ";\n"], ["\n  font: 400 16px/19px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
});
var Quantity = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 600 14px/24px ", ";\n  color: ", ";\n"], ["\n  font: 600 14px/24px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var GreyCircle = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  width: 19px;\n  height: 19px;\n  max-width: 19px;\n  max-height: 19px;\n  font: 600 14px/24px ", ";\n  color: ", ";\n  background: ", ";\n  padding: 11px;\n  margin-right: 10px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  width: 19px;\n  height: 19px;\n  max-width: 19px;\n  max-height: 19px;\n  font: 600 14px/24px ", ";\n  color: ", ";\n  background: ", ";\n  padding: 11px;\n  margin-right: 10px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var QuantityContainer = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var AddOnItem = function (_a) {
    var title = _a.title, price = _a.price, className = _a.className, quantity = _a.quantity;
    return (React__default.createElement(Container, { className: className },
        React__default.createElement(QuantityContainer, null,
            !!quantity && (React__default.createElement(GreyCircle, { className: "circle-block" },
                React__default.createElement(Quantity, { className: "quantity-block" }, quantity))),
            React__default.createElement(AddOnTitle, { className: "title-block" }, title)),
        React__default.createElement(AddOnPrice, { className: "price-block" }, price)));
};

exports.AddOnItem = AddOnItem;
